// extracted by mini-css-extract-plugin
export default {"legal-disclaimer":"PastPerformanceStatement_legal-disclaimer__hmtrZ"};